import { Box, Stack } from '@mui/material';
import { useDrawer } from 'components/drawers/inc-drawer/inc-drawer.hooks';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import {
  MultipleSearchQueryProvider,
  SearchParamsProvider,
} from 'components/search/search.context';
import {
  useSearchParams,
  useSearchQuery,
} from 'components/search/search.hooks';
import JobsStatusGate from 'components/jobs-status-gate/jobs-status-gate.component';
import { useSecuritySearchParams } from '../email-pulse.hooks';
import EmailPulseHeader from '../email-pulse-header/email-pulse-header.component';
import SecuritySummaryCards from './security-summary-cards.component';
import ApiDetailsDrawer from '../email-pulse-api-definitions/api-details-drawer.component';
import { transformEmailPulseDataGridResponse } from '../email-pulse.utils';
import {
  useGetEmailPulseSecuritySummaryQuery,
  useGetEmailPulseSecurityEmailsOpenedBreakdownQuery,
  useGetEmailPulseSecurityEmailsBouncedBreakdownQuery,
  useGetEmailPulseSecurityDataQuery,
  useExportEmailPulseSecurityMutation,
} from 'api/reports-service/email-pulse-hooks';
import SecurityDataGrid from './security-data-grid/security-data-grid.component';

const filteredSearchParams = [
  'storeIds',
  'campaignIds',
  'offerIds',
  'messageIds',
  'status',
];

const SearchParamsWrapper = () => {
  const searchParams = useSearchParams(useSecuritySearchParams());
  return (
    <SearchParamsProvider value={searchParams}>
      <Security />
    </SearchParamsProvider>
  );
};

const Security = () => {
  const { open, close, isOpen } = useDrawer();

  const securitySummary = useSearchQuery(useGetEmailPulseSecuritySummaryQuery, {
    filteredSearchParams,
  });

  const emailsOpenedBreakdown = useSearchQuery(
    useGetEmailPulseSecurityEmailsOpenedBreakdownQuery,
    {
      filteredSearchParams,
    },
  );

  const emailsBouncedBreakdown = useSearchQuery(
    useGetEmailPulseSecurityEmailsBouncedBreakdownQuery,
    {
      filteredSearchParams,
    },
  );

  const securityDataGrid = useSearchQuery(useGetEmailPulseSecurityDataQuery, {
    filteredSearchParams,
    getSearchResults: response =>
      transformEmailPulseDataGridResponse(response, 'id', 'emailTypeDisplay'),
  });

  return (
    <Stack marginTop={2}>
      <MultipleSearchQueryProvider
        value={{
          queries: {
            securitySummary,
            emailsOpenedBreakdown,
            emailsBouncedBreakdown,
            securityDataGrid,
          },
        }}
      >
        <Stack spacing={2}>
          <SearchToolbar />
          <EmailPulseHeader open={open} />

          {/* Summary Cards */}
          <SecuritySummaryCards />

          {/* Data Grid */}
          <Box height={{ xs: 400, sm: 600 }}>
            <SecurityDataGrid
              data-testid="Security.SecurityDataGrid"
              queryName="securityDataGrid"
              useExportMutation={useExportEmailPulseSecurityMutation}
            />
          </Box>
        </Stack>
      </MultipleSearchQueryProvider>
      <ApiDetailsDrawer isOpen={isOpen} close={close} />
    </Stack>
  );
};

export default function GatedPage() {
  return (
    <JobsStatusGate>
      <SearchParamsWrapper />
    </JobsStatusGate>
  );
}
